import { render, staticRenderFns } from "./AssistedGradingWritten.vue?vue&type=template&id=6d1ed7c8&scoped=true&"
import script from "./AssistedGradingWritten.vue?vue&type=script&lang=ts&"
export * from "./AssistedGradingWritten.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ed7c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
